import axios from 'axios';
import React,{useState, useEffect} from 'react';
import Box from "@mui/material/Box";
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from "@mui/material/IconButton";
import { url } from '../../../../Config';



export default function Crm_form(props) {

    const [opportunity_id, setOpportunityId] = useState(null);

    const [alertopen, setalertOpen] = useState(false);
    const [alertType, setalertType] = useState();
    const [AlertMessage, setalertmessage] = useState();
    
    
    const submitform = async (event) => {
        event.preventDefault();
        setalertOpen(false);
        const res = await axios.get(`${url}/api/crm-opinions-get/${opportunity_id}`);
        const resp = res.data;
        console.log(resp);
        if(resp.status == true) {
            setalertType("success");
            setalertOpen(true);
            setalertmessage(resp.data);
        }
        else {
            setalertType("error");
            setalertOpen(true);
            setalertmessage(resp);
        }
    }

  return (
    <div style={props.screenWidth > 760 ? {height : '90vh'} : null}>
      <div className='text-center mt-2 fs-4 fw-bold' style={{color: "#000078" }}>CRM Form</div>
      <form className='col-10 card p-3 mx-auto mt-lg-4 mt-md-4 mt-2' onSubmit={(e)=>{submitform(e)}}>
        <div className='mt-2 fw-bold'>
            Enter Opportunity ID:
        </div>
        <div className='mt-2'>
            <input className='form-control' value={opportunity_id} onChange={(e) => setOpportunityId(e.target.value)} required />
        </div>
         <Box className="mx-auto mt-1 mb-1" sx={{ width: "98%" }}>
                        <Collapse in={alertopen}>
                            <Alert
                            severity={alertType}
                            action={
                                <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setalertOpen(false);
                                }}
                                >
                                <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                            >
                            {AlertMessage}
                            </Alert>
                        </Collapse>
            </Box>
        <div className='mt-2'>
            <button className='btn btn-primary' type="submit">Submit</button>
        </div>
      </form>
    </div>
  )
}
